import { Box, Button, Divider, HStack, ModalBody, ModalFooter, Text, useToast } from "@chakra-ui/react"
import { Icon, Lottie, Modal } from "components"
import { useState } from "react"
import OneSignal from "react-onesignal"
import QRCode from "react-qr-code"

export default function Notification({ ...props }){

    const toast = useToast()
    const [ loading, setLoading ] = useState(false)
    const optedIn = OneSignal.User.PushSubscription.optedIn

    const handlePermission = async () => {
        setLoading(true)

        try{
            
            // Solicita permissão nativa
            await OneSignal.Notifications.requestPermission()
            
            // Verifica se a permissão foi negada
            if(!OneSignal.Notifications.permission){
                toast({ title: 'Não foi possível configurar as notificações. Tente novamente.', status: 'warning' })
                setLoading(false)
                return
            }
            
            // Assina opt-in
            await OneSignal.User.PushSubscription.optIn()

            toast({ title: 'Notificações ativadas com sucesso', status: 'success' })
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível ativar as notificações. Tente novamente.' })
        }

        setLoading(false)
    }

    const toggleOptIn = async () => {
        setLoading(true)
        optedIn ? await OneSignal.User.PushSubscription.optOut() : await OneSignal.User.PushSubscription.optIn()
        setLoading(false)
    }

    if(OneSignal.Notifications.permission) return(
    <Modal {...props}>
        <ModalBody textAlign="center">
            <Lottie animation="notification" width={180} options={{ loop: true }} />
            <Text fontSize="large" children={optedIn ? 'Notificações ativadas' : 'Notificações desativadas'} />
            <Text fontSize="small" children="Você já está apto a receber notificações neste dispositivo." />

            <Button 
                children={optedIn ? 'Desativar notificações' : 'Ativar notificações'} 
                leftIcon={<Icon name={optedIn ? 'cancel' : 'check'} />} 
                colorScheme={optedIn ? 'red' : 'teal'}
                variant="outline"
                onClick={toggleOptIn} 
                isLoading={loading} 
                mt={4} 
                minW="300px"
            />

            <Divider my={4} />

            <HStack textAlign="left" spacing={4} px={6}>
                <QRCode value="https://adm.bonificaoficial.com/allow-mobile-púsh" size={120} fgColor="orange" bgColor="transparent" />
                <Box>
                    <Text fontWeight="bold" children="Escaneie para ativar notificações no telefone" />
                </Box>
            </HStack>

            <Divider my={4} />

            <Button children="Fechar" minW="300px" onClick={props.onClose} />
        </ModalBody>
        <ModalFooter />
    </Modal>
    )

    return(
    <Modal {...props}>
        <ModalBody textAlign="center">
            <Lottie animation="notification" width={180} />
            <Text fontSize="large" children="Ativar notificações importantes" />
            <Text fontSize="small" children="Por favor, conceda permissão para envio de notificações na sua área de trabalho para que seja alertado sobre atualizações importantes." />

            <Button children="Continuar" mt={8} colorScheme="orange" minW="300px" loadingText="Clique em permitir na tela..." isLoading={loading} onClick={handlePermission} />
        </ModalBody>
        <ModalFooter />
    </Modal>
    )
}